import { createContext } from 'react';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

type RcnUserState = {
	authenticatedUserProfile: AuthenticatedUserProfile | undefined;
	updateAuthenticatedUserProfile: (authenticatedUserProfile: AuthenticatedUserProfile | undefined) => void;
	userFavourites: string[] | undefined;
	updateUserFavourites: (favourites: string[] | undefined) => void;
};

export const defaultRcnUserState: RcnUserState = {
	authenticatedUserProfile: undefined,
	updateAuthenticatedUserProfile: (profile: AuthenticatedUserProfile | undefined) =>
		console.log(`Default updateAuthenticatedUserProfile: ${profile}`),
	userFavourites: [],
	updateUserFavourites: (favourites: string[] | undefined) => console.log(`Default updateUserFavourites: ${favourites}`),
};

export const RcnUserContext = createContext<RcnUserState>(defaultRcnUserState);
